import { render, staticRenderFns } from "./topicDetailsHyglBg.vue?vue&type=template&id=9c38ee8e&scoped=true"
import script from "./topicDetailsHyglBg.vue?vue&type=script&lang=js"
export * from "./topicDetailsHyglBg.vue?vue&type=script&lang=js"
import style0 from "./topicDetailsHyglBg.vue?vue&type=style&index=0&id=9c38ee8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c38ee8e",
  null
  
)

export default component.exports